const FromArr = [{
		title: "状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "经销商：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "提交日期：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "选择日期",
		widthLeft: 160,
		widthRight: 160,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "确认日期：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "选择时间",
		widthLeft: 172,
		widthRight: 172,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "任务名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 170,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "留言未读：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		checked: false,
		hidden: false,
	}
]
export default FromArr;